import { media } from '@/media';
import styled from 'styled-components';

export const SubContentsWarpper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${media.mobile`
    margin-top: 12px;
    display: block;
  `}
`;

export const MenuWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
